import type { AvatarProps } from "@/components/ui/avatar.tsx";
import { RoutedLink } from "../components/RoutedLink.tsx";
import { PersonAvatar } from "./PersonAvatar.tsx";
import { usePersonProfilePath } from "./usePersonProfilePath.ts";

export interface PersonInlineLinkProps {
    personId: string;
    displayName: string;
    imageUrl?: string;
    avatarSize?: AvatarProps["size"];
}

export function PersonInlineLink({ personId, displayName, imageUrl, avatarSize = "xs" }: PersonInlineLinkProps) {
    const personProfilePath = usePersonProfilePath();

    return (
        <RoutedLink href={personProfilePath(personId)} className="text-fg group/person-link inline-flex min-w-0 items-center gap-1.5 hover:no-underline">
            <PersonAvatar person={{ displayName, imageUrl }} size={avatarSize} className="text-fg" />
            <span className="min-w-0 truncate text-sm font-medium underline-offset-4 group-hover/person-link:underline">{displayName}</span>
        </RoutedLink>
    );
}
